import { coerceFilterValues } from '#/modules/commonComponents/table/columnFilterUtils';

/**
 * 將 async filter option 的 value→label 寫入 cache（供 ListFilterStatus chip 還原）。
 * @param {Map<string, string>} cache
 * @param {{ value: string, label: string }[]} options
 * @param {string|string[]|undefined} [values] 有傳則只記住選中項
 */
export function rememberAsyncFilterLabels(cache, options = [], values) {
  if (!cache) {
    return;
  }

  const selected = values === undefined
    ? null
    : new Set(coerceFilterValues(values).map(String));

  options.forEach((option) => {
    if (option?.value == null || option?.label == null || option.label === '') {
      return;
    }

    const id = String(option.value);
    if (selected && !selected.has(id)) {
      return;
    }

    cache.set(id, option.label);
  });
}

/**
 * @param {Map<string, string>} cache
 * @param {string|string[]} values
 * @returns {string[]}
 */
export function resolveFromLabelCache(cache, values) {
  return coerceFilterValues(values).map((id) => (
    cache?.get(String(id)) ?? id
  ));
}

export function createAsyncFilterLabelCache() {
  return new Map();
}
